import React from "react";

import { ResponsibleDispatcherCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function responsibleDispatcher({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ResponsibleDispatcher,
		(item) => <Content item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default responsibleDispatcher;
